<template>
  <div class="alumni-unit-form">
    <div class="page-body">
      <van-form ref="formRef">
        <div class="card">
          <div class="section-head">
            <span class="section-bar" />
            <span class="section-title">基本信息</span>
          </div>
          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>单位名称</label
            >
            <van-field
              v-model="form.unitName"
              name="unitName"
              placeholder="请输入单位名称"
              class="input-like"
              maxlength="100"
              :rules="[{ required: true, message: '请填写单位名称' }]"
            />
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>所在地区</label
            >
            <van-field
              v-model="form.regionText"
              name="regionText"
              readonly
              clickable
              placeholder="请选择省/市/区"
              class="input-like"
              right-icon="arrow"
              :rules="[{ required: true, message: '请选择省/市/区' }]"
              @click="showRegion = true"
            />
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>详细地址</label
            >
            <van-field
              v-model="form.unitAddress"
              name="unitAddress"
              placeholder="请输入详细地址信息"
              class="input-like"
              maxlength="200"
              :rules="[{ required: true, message: '请输入详细地址信息' }]"
            />
          </div>

          <div class="field-block">
            <label class="field-label"><span class="req">*</span>联系人</label>
            <van-field
              v-model="form.contactPerson"
              name="contactPerson"
              placeholder="请输入联系人"
              class="input-like"
              maxlength="50"
              :rules="[{ required: true, message: '请输入联系人' }]"
            />
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>联系电话</label
            >
            <!-- 验证手机号 -->
            <van-field
              v-model="form.contactPhone"
              name="contactPhone"
              type="tel"
              placeholder="请输入联系电话"
              class="input-like"
              maxlength="20"
              :rules="[
                { required: true, message: '请输入联系电话' },
                { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' },
              ]"
            />
          </div>

          <div class="field-block">
            <label class="field-label">学校官网/公众号</label>
            <van-field
              v-model="form.officialSiteOrAccount"
              name="officialSiteOrAccount"
              placeholder="请输入学校官网/公众号"
              class="input-like"
              maxlength="200"
            />
          </div>

          <div class="field-block">
            <label class="field-label">现单位校友数量</label>
            <van-field
              v-model="form.alumniCountInUnit"
              name="alumniCountInUnit"
              placeholder="请输入人数"
              class="input-like"
              type="digit"
              maxlength="8"
            />
          </div>
        </div>

        <div class="card card--second">
          <div class="section-head">
            <span class="section-bar" />
            <span class="section-title">其他信息</span>
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>可输出资源</label
            >
            <van-field
              v-model="form.outputtableResources"
              name="outputtableResources"
              type="textarea"
              rows="6"
              autosize
              maxlength="2000"
              show-word-limit
              class="input-like input-like--textarea"
              :placeholder="placeholderOutput"
              :rules="[{ required: true, message: '请输入可输出资源' }]"
            />
          </div>

          <div class="field-block">
            <label class="field-label"
              ><span class="req">*</span>可接入资源</label
            >
            <van-field
              v-model="form.accessibleResources"
              name="accessibleResources"
              type="textarea"
              rows="6"
              autosize
              maxlength="2000"
              show-word-limit
              class="input-like input-like--textarea"
              :placeholder="placeholderInput"
              :rules="[{ required: true, message: '请输入可接入资源' }]"
            />
          </div>

          <div class="submit-wrap safe-bottom">
            <van-button
              block
              type="primary"
              class="submit-btn"
              native-type="submit"
              :loading="submitting"
              @click="validate"
            >
              提交
            </van-button>
          </div>
        </div>
      </van-form>
    </div>

    <van-popup v-model="showRegion" position="bottom" round>
      <!-- id,name -->
      <van-cascader
        v-model="regionCascaderVal"
        title="请选择省/市/区"
        :options="regionOptions"
        @close="showRegion = false"
        @finish="onRegionFinish"
      />
    </van-popup>
  </div>
</template>

<script>
// import { regionCascaderOptions } from "@/util/alumniRegion.js";
import { getResRegionTree } from "@/api/resource/resregion";
import { addAlumniUnit, getAlumniUnit } from "@/api/cms/alumni";
import { Toast } from "vant";
export default {
  name: "AlumniUnitForm",
  data() {
    return {
      submitting: false,
      showRegion: false,
      regionCascaderVal: "",
      regionOptions: [],
      placeholderOutput:
        "1.资源名称及类型简介\n2.功能与适用场景、特色与成效\n3.合作方与开放资源情况\n4.格式与使用权限（电子版/校本/可试用等）\n5.其他说明",
      placeholderInput:
        "1.需求方向\n2.希望对接的资源类型\n3.建设或技术要求\n4.具体合作诉求",
      form: {
        unitName: "",
        regionText: "",
        unitAddress: "",
        contactPerson: "",
        contactPhone: "",
        officialSiteOrAccount: "",
        alumniCountInUnit: "",
        outputtableResources: "",
        accessibleResources: "",
      },
      errors: {},
    };
  },
  created() {
    this.getResRegionTreeFn();
    this.getAlumniUnitFn();
  },
  methods: {
    getAlumniUnitFn() {
      getAlumniUnit().then((res) => {
        // console.log(res);
        let { provinceName, cityName, districtName } = res.data;
        this.form.regionText =
          provinceName + " / " + cityName + " / " + districtName;
        Object.assign(this.form, res.data);
        this.regionCascaderVal = res.data.districtCode;
      });
    },
    getResRegionTreeFn() {
      getResRegionTree({ maxType: 2 }).then((res) => {
        // 递归删除children为空或者children为空数组的对象
        const filterChildren = (data) => {
          return data.map((item) => {
            item.text = item.name;
            item.value = item.code;
            if (item.children && item.children.length > 0) {
              item.children = filterChildren(item.children);
            } else {
              delete item.children;
            }
            return item;
          });
        };
        let array = filterChildren(res.data);

        this.regionOptions = JSON.parse(JSON.stringify(array));
      });
    },
    onBack() {
      if (this.$router && window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.replace({ name: "AlumniSelect" });
      }
    },
    onRegionFinish({ selectedOptions }) {
      this.form.regionText = selectedOptions.map((o) => o.name).join(" / ");
      this.showRegion = false;
      this.form.provinceCode = selectedOptions[0].code;
      this.form.cityCode = selectedOptions[1].code;
      this.form.districtCode = selectedOptions[2].code;
      this.form.provinceName = selectedOptions[0].name;
      this.form.cityName = selectedOptions[1].name;
      this.form.districtName = selectedOptions[2].name;
      this.$delete(this.errors, "regionText");
    },
    onSubmit() {
      addAlumniUnit(JSON.parse(JSON.stringify(this.form)))
        .then(() => {
          if (this.form.id) {
            Toast.success("更新成功");
          } else {
            Toast.success("提交成功");
          }

          setTimeout(() => {
            this.submitting = false;
            this.$router.push({ path: "/alumni" });
          }, 1000);
        })
        .catch(() => {
          this.submitting = false;
        });
    },
    async validate() {
      this.submitting = true;
      try {
        await this.$refs.formRef.validate();
        this.onSubmit();
        // console.log(JSON.parse(JSON.stringify(this.form)));
      } catch (error) {
        // 跳转到第一个错误项
        this.$refs.formRef.scrollToField(error[0].name);
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$primary: #2f6bff;

.alumni-unit-form {
  min-height: 100vh;
  background: #f0f2f5;
  padding-bottom: 24px;
}

.alumni-nav {
  ::v-deep .van-nav-bar {
    background: $primary;
  }
  ::v-deep .van-nav-bar__title {
    color: #fff;
    font-weight: 600;
    font-size: 17px;
  }
  ::v-deep .van-nav-bar__content {
    height: 46px;
  }
}

.page-body {
  padding: 12px;
}

.card {
  background: #fff;
  border-radius: 12px;
  padding: 16px 14px 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  margin-bottom: 12px;
}

.card--second {
  padding-bottom: 4px;
}

.section-head {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.section-bar {
  width: 4px;
  height: 16px;
  background: $primary;
  border-radius: 2px;
  margin-right: 8px;
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
}

.field-block {
  margin-bottom: 16px;
}

.field-label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  font-weight: 500;
}

.req {
  color: #ee0a24;
  margin-right: 2px;
}

.input-like {
  // background: #f7f8fa;
  border-radius: 8px;
  padding: 10px 12px !important;

  ::v-deep .van-field__control {
    font-size: 15px;
    color: #333;

    &::placeholder {
      color: #bbb;
    }
  }

  ::v-deep .van-field__error-message {
    margin-top: 6px;
  }
}

.input-like--textarea {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.submit-wrap {
  padding: 20px 2px 12px;
}

.safe-bottom {
  padding-bottom: max(12px, env(safe-area-inset-bottom, 12px));
}

.submit-btn {
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  background: $primary;
  border: none;
}
</style>
